















import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import PipelineMenuWrapper from '../components/PipelineMenuWrapper.vue';
import LoadingPage from '../components/LoadingPage.vue';
import accounts, { ProductName, Provider, SignTabs } from '@/helpers/accountsIframe';
import i18n from '@/i18n';
import pipeline from '@/pipeline';
import Analytics from '@/helpers/analytics';

export default Vue.extend({
  components: {
    VueMarkdown,
    PipelineMenuWrapper,
    LoadingPage,
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    studentEmail(): string {
      return this.$store.getters.personalData?.email || '';
    },
    studentPhone(): string {
      return this.$store.getters.personalData?.phone || '';
    },
    studentEmailHasAccounts(): boolean {
      return this.$store.getters.studentEmailHasAccounts || false;
    },
    isLoggedInAccountsWithStudentEmail(): boolean {
      const { emailTokenD } = this.$store.getters;
      return emailTokenD === this.studentEmail;
    },
    studentEmailProviders(): Provider[] {
      return this.$store.getters.studentEmailProviders || [];
    },
    studentAccountsHasSocialLogin(): boolean {
      const { GOOGLE, FACEBOOK, APPLE } = Provider;
      return this.studentEmailProviders.some((provider: Provider) =>
        [GOOGLE, FACEBOOK, APPLE].includes(provider),
      );
    },
    currentAccountsStatus(): 'signIn' | 'signUp' | 'signInSocial' {
      const { DESCOMPLICA } = Provider;
      const shouldSignIn = this.studentEmailHasAccounts;

      if (shouldSignIn) {
        Analytics.trackMixpanel('Já tinha accounts - estava deslogado');
        const shouldSignInWithSocial =
          shouldSignIn &&
          !this.studentEmailProviders.includes(DESCOMPLICA) &&
          this.studentAccountsHasSocialLogin;

        if (shouldSignInWithSocial) return 'signInSocial';

        return 'signIn';
      }

      Analytics.trackMixpanel('Não tinha accounts');
      return 'signUp';
    },
    title(): string {
      return i18n.t(`${this.currentAccountsStatus}.title`);
    },
    explanation(): string {
      return i18n.t(`${this.currentAccountsStatus}.explanation`);
    },
    accountsPath(): string {
      switch (this.currentAccountsStatus) {
        case 'signIn':
          return 'entrar';

        case 'signInSocial':
          return 'login-social';

        default:
          return 'cadastrar';
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch('GET_USER_ACCOUNTS');
    this.isLoading = false;
    this.loadAccountsAsIframe();
  },
  created() {
    const shouldAccessThePlatform =
      this.studentEmailHasAccounts && this.isLoggedInAccountsWithStudentEmail;
    if (shouldAccessThePlatform) pipeline.next();
  },
  methods: {
    loadAccountsAsIframe() {
      const { SignIn, SignUp } = SignTabs;
      const signInUrl = `${process.env.VUE_APP_ACCOUNTS_URL}/${this.accountsPath}/`;
      const isSocialLogin = this.accountsPath === 'login-social';
      const socialButtonsToHide = this.studentEmailProviders.length
        ? Object.values(Provider).filter(
            provider =>
              !this.studentEmailProviders.includes(provider) && provider !== Provider.DESCOMPLICA,
          )
        : this.studentEmailProviders;

      const params = {
        url: signInUrl,
        email: this.studentEmail,
        phone: this.studentPhone,
        hideTabs: [SignIn, SignUp],
        productName: ProductName.UNDERGRAD_DESCOMPLICA,
        hideSocialMedia: !isSocialLogin,
        hidePassword: isSocialLogin,
        hideSocialButtons: socialButtonsToHide,
        hideHeaders: true,
        hideFooter: true,
        disableEmail: true,
        disablePhone: true,
      };

      accounts.loginWithIframe(params, '.accounts__container', 'accounts-iframe');
    },
  },
});
